import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'
import jwt_decode from 'jwt-decode'
import { setErrorLog } from './DashboardService'

const unauthorizedCode = [401]

let projectInfo
const updateProjectInfo = () => {
    projectInfo = store.getState().auth.user
}

const BaseService = axios.create({
    timeout: 600000,
    baseURL: appConfig.apiPrefix,
})

BaseService.interceptors.request.use(config => {
    // Servisler FormData gövdesine de 'Content-Type: application/json' veriyor. axios 1.x bu başlıkla
    // FormData'yı JSON'a çevirir (0.27 xhr adaptörü başlığı siliyordu); başlığı kaldır, tarayıcı multipart sınırını ekler.
    if (typeof FormData !== 'undefined' && config.data instanceof FormData && config.headers) {
        if (typeof config.headers.delete === 'function') {
            config.headers.delete('Content-Type')
        } else {
            delete config.headers['Content-Type']
            delete config.headers['content-type']
        }
    }

    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
    const persistData = deepParseJson(rawPersistData)
    
    const accessToken = persistData.auth.session.token
    
    // Callback fonksiyonu çağır
    updateProjectInfo()

    // Değişkeni kullan
    if (accessToken && projectInfo) {
        const decoded = jwt_decode(accessToken);
        const expirationTime = decoded.exp;
        const currentTime = Math.floor(Date.now() / 1000); // Şu anki zamanı Unix timestamp olarak al

        if (currentTime >= expirationTime) {
            store.dispatch(onSignOutSuccess());
            return Promise.reject(new Error('Token expired'));
        }

        if(config.url !== 'https://nosimia.com.tr/efes/servis' && config.url!== 'https://nosimia.com.tr/efes/testjson'){
            config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`
            config.headers['project_id'] = projectInfo.project_id
        }
    }
    return config
}, error => {
    return Promise.reject(error)
})
/*
BaseService.interceptors.response.use(
    response => response,
    error => {
        const { response } = error

        if (response && unauthorizedCode.includes(response.status)) {
            store.dispatch(onSignOutSuccess())
        }

        return Promise.reject(error)
    }
)
*/
BaseService.interceptors.response.use(
    response => response,
    error => {
        const { response } = error

        if (response && unauthorizedCode.includes(response.status)) {
            store.dispatch(onSignOutSuccess())
        }

        // Hata durumunda log servisine istek gönder (log servisine yapılan istekler ve 404 hataları hariç)
        if (response && error.config) {
            const requestUrl = error.config.url || error.config.baseURL || ''
            const logServiceUrl = appConfig.APIURL + 'setlog'
            
            // 404 hatalarında log gönderme
            if (response.status === 404) {
                return Promise.reject(error)
            }
            
            // Log servisine yapılan istekler için log gönderme (sonsuz döngüyü önle)
            if (requestUrl.includes('setlog') || requestUrl === logServiceUrl) {
                return Promise.reject(error)
            }

            try {
                const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
                const persistData = deepParseJson(rawPersistData)
                const accessToken = persistData?.auth?.session?.token
                
                let userId = null
                if (accessToken) {
                    try {
                        const decoded = jwt_decode(accessToken)
                        userId = decoded.user_id || decoded.id || decoded.sub || null
                    } catch (e) {
                        // Token decode hatası
                    }
                }

                // Log verilerini hazırla
                const logData = {
                    user_id: userId || 0,
                    occurred_at: new Date().toISOString().slice(0, 19),
                    platform: "WEB",
                    requested_url: requestUrl,
                    request_method: (error.config.method || 'GET').toUpperCase(),
                    client_ip: window.location.hostname || '',
                    request_header: error.config.headers || {},
                    request_dict: error.config.data || error.config.params || {},
                    response_status_code: response.status || 0,
                    response_dict: response.data || {},
                    log_level: response.status >= 500 ? "ERROR" : response.status >= 400 ? "ERROR" : "INFO",
                    message: error.message || 'Request failed',
                    stack_trace: error.stack || '',
                    device_info: navigator.userAgent || '',
                    browser_info: navigator.userAgent || '',
                    app_version: "1.0.0",
                    send_to_client: false
                }

                // Log servisine istek gönder (asenkron, ana işlemi engellemez)
                setErrorLog(logData)
            } catch (logError) {
                // Log gönderme hatası durumunda sessizce devam et
                console.error('Log gönderme hatası:', logError)
            }
        }

        return Promise.reject(error)
    }
)
export default BaseService